// extracted by mini-css-extract-plugin
export default {"container":"statsInfo_container__dYkV-","king":"statsInfo_king__MrzKu","tittle":"statsInfo_tittle__aZE0q","kingSection":"statsInfo_kingSection__MGY0o"};